import React, { useState } from "react";
import { PatientGoal } from "../../../goal_templates/classes/patient_goal_class";

export const SelectionStatus = ({
  element,
  setModalStatus,
  setSelection,
  viewOnly,
}) => {
  var goal, empty, plus, check, minus;

  if (element.type.name.includes("GoalTemplate")) {
    goal = PatientGoal.findByTemplateId(element.id);
  }

  if (element.type.name.includes("PatientGoal")) {
    goal = element;
  }

  const deactivateGoal = (template) => {
    if (viewOnly) return;
    setModalStatus("deactivate");
    setSelection(template);
  };

  const activateGoal = (template) => {
    if (viewOnly) return;
    setModalStatus("activate");
    setSelection(template);
  };

  const removeGoal = (template) => {
    if (viewOnly) return;
    setModalStatus("remove");
    setSelection(template);
  };

  const restoreGoal = (template) => {
    if (viewOnly) return;
    setModalStatus("restore");
    setSelection(template);
  };

  let emptyClass = `icon-check-empty ${
    viewOnly ? "check-icon-view-only" : "check-icon"
  } check-icon-empty`;

  empty = <i className={emptyClass} onClick={() => activateGoal(element)}></i>;

  let plusClass = `icon-check-add ${
    viewOnly ? "check-icon-view-only" : "check-icon"
  } check-icon-add`;

  plus = <i className={plusClass} onClick={() => deactivateGoal(element)}></i>;

  let checkClass = `icon-check-added ${
    viewOnly ? "check-icon-view-only" : "check-icon"
  } check-icon-added`;
  check = <i className={checkClass} onClick={() => removeGoal(element)}></i>;

  let minusClass = `icon-check-remove ${
    viewOnly ? "check-icon-view-only" : "check-icon"
  } check-icon-remove`;
  minus = <i className={minusClass} onClick={() => restoreGoal(element)}></i>;

  const determineSelectionStatus = () => {
    if (!goal) return empty; // No Goal
    if (goal.isExistingGoal() && !goal.isSelectedForDeletion()) return check; // is goal with Id and IS NOT in the 'removedPatientGoals' array.
    if (!goal.isExistingGoal() && goal.isSelectedForSaving()) return plus; // is goal with NO Id and IS in the 'selectedPatientGoals' array.
    if (goal.isExistingGoal() && goal.isSelectedForDeletion()) return minus; // is goal with Id and IS in the 'removedPatientGoals' array.
    if (!goal.isExistingGoal() && !goal.isSelectedForSaving()) return empty; // is goal with NO Id and IS in the 'selectedPatientGoals' array.
    if (!goal.isExistingGoal() && goal.isSelectedForDeletion()) return empty; // is goal with NO Id and IS in the 'removedPatientGoals' array.
    return empty;
  };

  return (
    <div className="patient-goal-selector-wrapper">
      {determineSelectionStatus()}
    </div>
  );
};
